
import Layout from '../../components/layout'
import NaasCard from "../../components/naascard";
import Slider from '../../components/slider'

import Stock1 from '../../assets/images/stock/stock-1.jpg'
import Stock2 from '../../assets/images/stock/stock-2.jpg'
import Stock5 from '../../assets/images/stock/stock-5.jpg'

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { useState, useEffect } from 'react'


export default function OfferPage() {


  const services = [
    {
      title: "AceOps",
      description: "Våra tekniker är alltid redo att hjälpa till när ni behöver det.",
      included: ["Någon att rådfråga", "Rabatterade timpriser", "Operations på ert sätt", "Löpande förbättringsförslag"],
      selectRange: { from: 0, to: 25 },
      image: Stock1
    },
    {
      title: "AceNoc",
      description: "Vi kontaktar er när vi ser någonting som behöver åtgärdas.",
      included: ["Allt som ingår i AceOps", "Aktiv övervakning", "Konfigurationsbackuper", "Proaktiv approach"],
      selectRange: { from: 26, to: 75 },
      image: Stock2
    },
    {
      title: "AceNaaS",
      description: "Vi sätter upp och underhåller ditt nätverk efter konstens alla regler.",
      included: ["All inclusive", "Förutsägbar kostnad", "Inkluderar hårdvara"],
      selectRange: { from: 76, to: 100 },
      image: Stock5
    }
  ]
  const [responsibility, setResponsibility] = useState(25)
  const [selectedNaas, setSelectedNaas] = useState(undefined)

  const [MoreNext, setMoreNext] = useState(true)
  const [MorePrev, setMorePrev] = useState(false)

  const respSetter = (level) => {
    setResponsibility(level.target.value)
  }

  const setNaas = () => {
    for (const [i, value] of Object.entries(services)) {
      if (responsibility >= value.selectRange.from && responsibility <= value.selectRange.to) {
        setSelectedNaas(value)
      }
    }
  }

  const respToNext = () => {
    if (selectedNaas.title == "AceOps") {
      setResponsibility(50)
    } else if (selectedNaas.title == "AceNoc") {
      setResponsibility(100)
    }
  }

  const respToPrev = () => {
    console.log(selectedNaas.title)
    if (selectedNaas.title == "AceNoc") {
      setResponsibility(20)
    } else if (selectedNaas.title == "AceNaaS") {
      setResponsibility(50)
    }
  }

  useEffect(() => {
    setNaas()
  }, [responsibility])

  useEffect(() => {
    if (selectedNaas) {
      if (selectedNaas.title == "AceOps") {
        setMoreNext(true)
        setMorePrev(false)
      } else if (selectedNaas.title == "AceNoc") {
        setMoreNext(true)
        setMorePrev(true)
      } else {
        setMoreNext(false)
        setMorePrev(true)
      }
    }
  }, [selectedNaas])

  return (

    <Layout >
      <div id="naas" className="section">
        <div className="flex flex-col sm:px-8 text-center">
          <h1 className="text-4xl py-8"><span className="text-sky-500">Kompetens</span> som tjänst</h1>
          <p className="text-lg"></p>

          <div className="py-8">
            <p className="text-2xl text-center">Hur vill ni fördela ansvaret mellan er och er partner?</p>
            <div >



            </div>
            <Slider
              onChange={respSetter}
              value={responsibility}
            />

            <div className="flex flex-row justify-between">
              <div className="px-4 text-gray-400">In house</div>
              <div className="px-4 text-gray-400">Partner</div>
            </div>

            <div className="flex flex-row justify-center w-full">
              <div className="flex flex-row sm:w-2/3 w-full justify-between">

                {!MorePrev ? <div style={{ width: 52, height: 52 }}></div> :
                  <button
                    type="button"
                    onClick={() => respToPrev()}
                  >
                    <ArrowBackIosNewIcon sx={{ width: 52, height: 52, color: 'info.main' }} />
                  </button>
                }

                <div className="relative w-[275px] sm:w-[600px] h-[350px] flex justify-center mt-8">
                  {services.map((item, index) => (
                    <div className={`deliverable-${index}`} key={index}>
                      <div className="">
                        <NaasCard
                          title={item.title}
                          description={item.description}
                          sliderLevel={responsibility}
                          selectedRange={item.selectRange}
                          included={item.included}
                          image={item.image}
                        />
                      </div>
                    </div>
                  )
                  )}
                </div>

                {!MoreNext ? <div style={{ width: 52, height: 52 }}></div> :
                  <button
                    type="button"
                    onClick={() => respToNext()}
                  >
                    <ArrowForwardIosIcon sx={{ width: 52, height: 52, color: 'info.main' }} />
                  </button>
                }
              </div>
            </div>
          </div>


        </div>
      </div>
    </Layout>
  )
}
